<template>
    <ai-tree-list-edit
        ref='treeRef'
        :meta="treeMeta"
        :to-remove-toolbar-items-names="removeTreeToolbarBtns"
    ></ai-tree-list-edit>
</template>
<script>
export default {
    name: 'ds-gvs-norm-view',
};
</script>
<script setup>
import { onMounted, ref } from 'vue';
import AiTreeListEdit from '@/components/ai-tree-list-edit/ai-tree-list-edit.vue';

const treeRef = ref(null);

onMounted(async () => {
    await treeRef.value?.setDataSource();
    treeRef.value?.expandAll();
});

const removeTreeToolbarBtns = ['choice', 'find-prev', 'find', 'find-start', 'find-next', 'expandOrCollapseButton','copy', 'moveTo',
    'moveSave', 'edit', 'searchPanel', 'show-column-chooser', 'addSibling', 'addChild', 'delete', 'save', 'cut', 'put'];

const treeMeta = {
    keyExpr: 'kod_norm_gvs',
    parentIdExpr: 'kod_parent',
    selectButtonMode: 'single',
    selectionMode: 'single',
    findTool: 'filter',
    columns: [
        {
            'name': 'kod_norm_gvs',
            'caption': 'Код',
            'dataField': 'kod_norm_gvs',
            'allowEditing': false,
            'index': 1,
            'visible': false
        },
        {
            'name': 'kod_parent',
            'caption': 'Код родителя',
            'dataField': 'kod_parent',
            'allowEditing': false,
            'index': 2,
            'visible': false
        },
        {
            'name': 'name_norm_gvs',
            'caption': 'Наименование',
            'dataField': 'name_norm_gvs',
            'allowEditing': false,
            'width': 407,
            'minWidth': 407,
            'index': 3,
            'visible': true
        },
        {
            'name': 'k',
            'caption': 'Коэффициент',
            'dataField': 'k',
            'allowEditing': false,
            'width': 300,
            'minWidth': 300,
            'index': 4,
            'visible': true
        }
    ],
    api: {
        select: 'tep-nsi./tep-nsi/ds-gvs-norm/select/get'
    },
    viewId: 'ds-gvs-norm-view'
}
</script>
<style scoped></style>
